var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-2" },
    [
      _c(
        "div",
        {
          staticClass: "mb-1 headline",
          staticStyle: { "text-align": "center" }
        },
        [
          _vm._v(
            _vm._s("Screen Time from previous " + this.hoursLoaded + " hours")
          )
        ]
      ),
      _c("v-divider"),
      _c("bar-chart", {
        attrs: {
          data: _vm.screenUsage,
          ytitle: "Hour of day",
          xtitle: "Screen time",
          suffix: " mins",
          height: _vm.screenUsage.length * 20 + 100 + "px",
          colors: [_vm.colorAccent, _vm.colorPrimary]
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }